// Garden Gnome Software - Skin
// Pano2VR 5.2.4/15996
// Filename: simplex.ggsk
// Generated Sa Jun 16 19:08:27 2018

function pano2vrSkin(player, base) {
  var ggSkinVars = [];
  var me = this;
  var flag = false;
  var isControlInfoVisible = false;
  var isControlInfoMouseDown = false;
  var isWrongUse = false;
  var nodeMarker = [];
  var activeNodeMarker = [];
  this.player = player;
  this.player.skinObj = this;
  this.divSkin = player.divSkin;
  this.ggUserdata = me.player.userdata;
  this.lastSize = { w: -1, h: -1 };
  var basePath = "/common/portal_static/ci2017/vendors/pano2vr/";
  var ICON_PATH = "/common/portal_static/ci2017/vendors/pano2vr/icons/";
  // auto detect base path
  if (base == "?") {
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      if (src.indexOf("skin.js") >= 0) {
        var p = src.lastIndexOf("/");
        if (p >= 0) {
          basePath = src.substr(0, p + 1);
        }
      }
    }
  } else if (base) {
    basePath = base;
  }
  this.elementMouseDown = [];
  this.elementMouseOver = [];
  var cssPrefix = "";
  var domTransition = "transition";
  var domTransform = "transform";
  var prefixes = "Webkit,Moz,O,ms,Ms".split(",");
  var i;
  if (typeof document.body.style["transform"] == "undefined") {
    for (var i = 0; i < prefixes.length; i++) {
      if (
        typeof document.body.style[prefixes[i] + "Transform"] !== "undefined"
      ) {
        cssPrefix = "-" + prefixes[i].toLowerCase() + "-";
        domTransition = prefixes[i] + "Transition";
        domTransform = prefixes[i] + "Transform";
      }
    }
  }

  this.player.setMargins(0, 0, 0, 0);

  this.updateSize = function (startElement) {
    var stack = [];
    stack.push(startElement);
    while (stack.length > 0) {
      var e = stack.pop();
      if (e.ggUpdatePosition) {
        e.ggUpdatePosition();
      }
      if (e.hasChildNodes()) {
        for (var i = 0; i < e.childNodes.length; i++) {
          stack.push(e.childNodes[i]);
        }
      }
    }
  };

  parameterToTransform = function (p) {
    var hs =
      "translate(" +
      p.rx +
      "px," +
      p.ry +
      "px) rotate(" +
      p.a +
      "deg) scale(" +
      p.sx +
      "," +
      p.sy +
      ")";
    return hs;
  };

  this.findElements = function (id, regex) {
    var r = [];
    var stack = [];
    var pat = new RegExp(id, "");
    stack.push(me.divSkin);
    while (stack.length > 0) {
      var e = stack.pop();
      if (regex) {
        if (pat.test(e.ggId)) r.push(e);
      } else {
        if (e.ggId == id) r.push(e);
      }
      if (e.hasChildNodes()) {
        for (var i = 0; i < e.childNodes.length; i++) {
          stack.push(e.childNodes[i]);
        }
      }
    }
    return r;
  };

  this.addSkin = function () {
    var hs = "";
    this.ggCurrentTime = new Date().getTime();
    this._controlInfo = document.createElement("div");
    this._controlInfo.ggId = "controlInfo";
    this._controlInfo.ggTop = 0;
    this._controlInfo.ggLeft = 0;
    this._controlInfo.ggBottom = 0;
    this._controlInfo.ggRight = 0;
    this._controlInfo.className = "ggskin ggskin_container";
    this._controlInfo.ggType = "container";
    hs = "";
    hs += "position: absolute;";
    hs += "left: 0;";
    hs += "right: 0;";
    hs += "top: 0;";
    hs += "bottom: 0;";
    hs += "visibility: inherit;";
    hs += "pointer-events: all;";
    hs += "opacity: 0;";
    hs += "transition: opacity .15s linear;";
    hs += "background-color: rgba(0,0,0,.75);";
    this._controlInfo.setAttribute("style", hs);
    this._controlInfo.style[domTransform + "Origin"] = "50% 50%";
    me._controlInfo.ggIsActive = function () {
      return false;
    };
    me._controlInfo.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    };
    this._controlInfo.onmousedown = function () {
      isControlInfoMouseDown = true;
      if (isControlInfoVisible) return;
      isWrongUse = true;
      var self = this;
      window.setTimeout(function () {
        if (isWrongUse) {
          self.style.opacity = 1;
          isControlInfoVisible = true;
        }
      }, 500);
    };
    this._controlInfo.onmouseup = function () {
      isControlInfoMouseDown = false;
    };
    this._controlInfo.onmousemove = this._controlInfo.ontouchmove =
      function () {
        if (isControlInfoMouseDown && isWrongUse) {
          this.style.opacity = 0;
          isControlInfoVisible = false;
          isWrongUse = false;
        }
      };
    this._controlInfo.ggUpdatePosition = function (useTransition) {
      if (this.parentNode) {
        this.style.right = 0;
        this.style.top = 0;
        this.style.bottom = 0;
        this.style.left = 0;
      }
    };

    this._controlInfo__center = document.createElement("div");
    this._controlInfo__center.ggId = "controlInfo__center";
    this._controlInfo__center.ggTop = 0;
    this._controlInfo__center.ggLeft = 0;
    this._controlInfo__center.ggRight = 0;
    this._controlInfo__center.className = "ggskin ggskin_container";
    this._controlInfo__center.ggType = "container";
    hs = "";
    hs += "position: absolute;";
    hs += "left: 0;";
    hs += "right: 0;";
    hs += "top: 50%;";
    hs += "text-align: center;";
    hs += "visibility: inherit;";
    hs += "pointer-events: none;";
    this._controlInfo__center.setAttribute("style", hs);
    this._controlInfo__center.style[domTransform + "Origin"] = "50% 50%";
    me._controlInfo__center.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._controlInfo__center.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._controlInfo__center.ggUpdatePosition = function (useTransition) {
      if (this.parentNode) {
        this.style.right = 0;
        this.style.left = 0;
        var h = this.offsetHeight;
        this.style.top = "calc((100% - " + h + "px) / 2)";
      }
    };
    var icon = document.createElement("img");
    icon.setAttribute("src", ICON_PATH + "wb-icon-90__360--active.svg");
    hs = "";
    hs += "display : inline-block;";
    hs += "width : 64px;";
    hs += "height : 64px;";
    hs += "margin-bottom : 16px;";
    icon.setAttribute("style", hs);
    this._controlInfo__center.appendChild(icon);
    var text = document.createElement("div");
    hs = "";
    hs += "font-size: 1.1em;";
    text.setAttribute("style", hs);
    var translation = "";
    if (typeof $ !== "undefined") {
      translation = atob(
        $("#interior-spin-wrong-use-message").attr("data-translation")
      );
    }
    text.innerHTML = translation;
    this._controlInfo__center.appendChild(text);
    this._controlInfo.appendChild(this._controlInfo__center);

    this.divSkin.appendChild(this._controlInfo);
    this._controller = document.createElement("div");
    this._controller.ggId = "controller";
    this._controller.ggRight = 0;
    this._controller.ggTop = 0;
    this._controller.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._controller.ggVisible = true;
    this._controller.className = "ggskin ggskin_container ";
    this._controller.ggType = "container";
    hs = "";
    hs += "height : 100%;";
    hs += "right : 0;";
    hs += "position : absolute;";
    hs += "top : 0;";
    hs += "visibility : inherit;";
    hs += "width : 64px;";
    hs += "pointer-events:none;";
    this._controller.setAttribute("style", hs);
    this._controller.style[domTransform + "Origin"] = "50% 50%";
    me._controller.ggIsActive = function () {
      return false;
    };
    me._controller.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    };
    this._controller.ggUpdatePosition = function (useTransition) {
      if (useTransition === "undefined") {
        useTransition = false;
      }
      if (!useTransition) {
        this.style[domTransition] = "none";
      }
      if (this.parentNode) {
        var h = this.parentNode.offsetHeight;
        this.style.right = 0;
        this.style.top = 0;
        this.style.height = h + "px";
        this.style.width = "64px";
      }
    };
    this._zoomin = document.createElement("div");
    this._zoomin__img = document.createElement("img");
    this._zoomin__img.className = "ggskin ggskin_svg";
    this._zoomin__img.setAttribute(
      "src",
      ICON_PATH + "wb-icon-424__zoom-in-2--default.svg"
    );
    this._zoomin__img.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
    );
    this._zoomin__img["ondragstart"] = function () {
      return false;
    };
    this._zoomin.appendChild(this._zoomin__img);
    this._zoomin__imgo = document.createElement("img");
    this._zoomin__imgo.className = "ggskin ggskin_svg";
    this._zoomin__imgo.setAttribute(
      "src",
      ICON_PATH + "wb-icon-424__zoom-in-2--active.svg"
    );
    this._zoomin__imgo.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;"
    );
    this._zoomin__imgo["ondragstart"] = function () {
      return false;
    };
    this._zoomin.appendChild(this._zoomin__imgo);
    this._zoomin.ggId = "zoomin";
    this._zoomin.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._zoomin.ggVisible = true;
    this._zoomin.className = "ggskin ggskin_svg ";
    this._zoomin.ggType = "svg";
    hs = "";
    hs += "cursor : pointer;";
    hs += "height : 32px;";
    hs += "right : 16px;";
    hs += "position : absolute;";
    hs += "bottom : 80px;";
    hs += "visibility : inherit;";
    hs += "width : 32px;";
    hs += "pointer-events:auto;";
    this._zoomin.setAttribute("style", hs);
    this._zoomin.style[domTransform + "Origin"] = "50% 50%";
    me._zoomin.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._zoomin.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._zoomin.onmouseover = function (e) {
      me._zoomin__img.style.visibility = "hidden";
      me._zoomin__imgo.style.visibility = "inherit";
    };
    this._zoomin.onmouseout = function (e) {
      me._zoomin__img.style.visibility = "inherit";
      me._zoomin__imgo.style.visibility = "hidden";
      me.elementMouseDown["zoomin"] = false;
    };
    this._zoomin.onmousedown = function (e) {
      me.elementMouseDown["zoomin"] = true;
    };
    this._zoomin.onmouseup = function (e) {
      me.elementMouseDown["zoomin"] = false;
    };
    this._zoomin.ontouchend = function (e) {
      me.elementMouseDown["zoomin"] = false;
    };
    this._zoomin.ggUpdatePosition = function (useTransition) {};
    this._controller.appendChild(this._zoomin);
    this._zoomout = document.createElement("div");
    this._zoomout__img = document.createElement("img");
    this._zoomout__img.className = "ggskin ggskin_svg";
    this._zoomout__img.setAttribute(
      "src",
      ICON_PATH + "wb-icon-426__zoom-out-2--default.svg"
    );
    this._zoomout__img.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
    );
    this._zoomout__img["ondragstart"] = function () {
      return false;
    };
    this._zoomout.appendChild(this._zoomout__img);
    this._zoomout__imgo = document.createElement("img");
    this._zoomout__imgo.className = "ggskin ggskin_svg";
    this._zoomout__imgo.setAttribute(
      "src",
      ICON_PATH + "wb-icon-426__zoom-out-2--active.svg"
    );
    this._zoomout__imgo.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;"
    );
    this._zoomout__imgo["ondragstart"] = function () {
      return false;
    };
    this._zoomout.appendChild(this._zoomout__imgo);
    this._zoomout.ggId = "zoomout";
    this._zoomout.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._zoomout.ggVisible = true;
    this._zoomout.className = "ggskin ggskin_svg ";
    this._zoomout.ggType = "svg";
    hs = "";
    hs += "cursor : pointer;";
    hs += "height : 32px;";
    hs += "right : 16px;";
    hs += "position : absolute;";
    hs += "bottom : 32px;";
    hs += "visibility : inherit;";
    hs += "width : 32px;";
    hs += "pointer-events:auto;";
    this._zoomout.setAttribute("style", hs);
    this._zoomout.style[domTransform + "Origin"] = "50% 50%";
    me._zoomout.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._zoomout.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._zoomout.onmouseover = function (e) {
      me._zoomout__img.style.visibility = "hidden";
      me._zoomout__imgo.style.visibility = "inherit";
    };
    this._zoomout.onmouseout = function (e) {
      me._zoomout__img.style.visibility = "inherit";
      me._zoomout__imgo.style.visibility = "hidden";
      me.elementMouseDown["zoomout"] = false;
    };
    this._zoomout.onmousedown = function (e) {
      me.elementMouseDown["zoomout"] = true;
    };
    this._zoomout.onmouseup = function (e) {
      me.elementMouseDown["zoomout"] = false;
    };
    this._zoomout.ontouchend = function (e) {
      me.elementMouseDown["zoomout"] = false;
    };
    this._zoomout.ggUpdatePosition = function (useTransition) {};
    this._controller.appendChild(this._zoomout);
    this._fullscreen = document.createElement("div");
    this._fullscreen__img = document.createElement("img");
    this._fullscreen__img.className = "ggskin ggskin_svg";
    this._fullscreen__img.setAttribute(
      "src",
      ICON_PATH + "wb-icon-208__screenmax--default.svg"
    );
    this._fullscreen__img.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
    );
    this._fullscreen__img["ondragstart"] = function () {
      return false;
    };
    this._fullscreen.appendChild(this._fullscreen__img);
    this._fullscreen__imgo = document.createElement("img");
    this._fullscreen__imgo.className = "ggskin ggskin_svg";
    this._fullscreen__imgo.setAttribute(
      "src",
      ICON_PATH + "wb-icon-208__screenmax--active.svg"
    );
    this._fullscreen__imgo.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;"
    );
    this._fullscreen__imgo["ondragstart"] = function () {
      return false;
    };
    this._fullscreen.appendChild(this._fullscreen__imgo);
    this._fullscreen.ggId = "fullscreen";
    this._fullscreen.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._fullscreen.ggVisible = true;
    this._fullscreen.className = "ggskin ggskin_svg ";
    this._fullscreen.ggType = "svg";
    hs = "";
    hs += "cursor : pointer;";
    hs += "height : 32px;";
    hs += "right : 16px;";
    hs += "position : absolute;";
    hs += "top : 16px;";
    hs += "visibility : inherit;";
    hs += "width : 32px;";
    hs += "pointer-events:auto;";
    this._fullscreen.setAttribute("style", hs);
    this._fullscreen.style[domTransform + "Origin"] = "50% 50%";
    me._fullscreen.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._fullscreen.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._fullscreen.onclick = function (e) {
      me.player.toggleFullscreen();
    };
    this._fullscreen.onmouseover = function (e) {
      me._fullscreen__img.style.visibility = "hidden";
      me._fullscreen__imgo.style.visibility = "inherit";
    };
    this._fullscreen.onmouseout = function (e) {
      me._fullscreen__img.style.visibility = "inherit";
      me._fullscreen__imgo.style.visibility = "hidden";
    };
    this._fullscreen.ggUpdatePosition = function (useTransition) {};
    this._controller.appendChild(this._fullscreen);
    this.divSkin.appendChild(this._controller);
    this._loading = document.createElement("div");
    this._loading.ggId = "loading";
    this._loading.ggLeft = -105;
    this._loading.ggTop = -30;
    this._loading.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._loading.ggVisible = true;
    this._loading.className = "ggskin ggskin_container ";
    this._loading.ggType = "container";
    hs = "";
    hs += "height : 60px;";
    hs += "left : -105px;";
    hs += "position : absolute;";
    hs += "top : -30px;";
    hs += "visibility : inherit;";
    hs += "width : 210px;";
    hs += "pointer-events:none;";
    this._loading.setAttribute("style", hs);
    this._loading.style[domTransform + "Origin"] = "50% 50%";
    me._loading.ggIsActive = function () {
      return false;
    };
    me._loading.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    };
    this._loading.onclick = function (e) {
      me._loading.style[domTransition] = "none";
      me._loading.style.visibility = "hidden";
      me._loading.ggVisible = false;
    };
    this._loading.ggUpdatePosition = function (useTransition) {
      if (useTransition === "undefined") {
        useTransition = false;
      }
      if (!useTransition) {
        this.style[domTransition] = "none";
      }
      if (this.parentNode) {
        var w = this.parentNode.offsetWidth;
        this.style.left = this.ggLeft - 0 + w / 2 + "px";
        var h = this.parentNode.offsetHeight;
        this.style.top = this.ggTop - 0 + h / 2 + "px";
      }
    };
    this._loadingbg = document.createElement("div");
    this._loadingbg.ggId = "loadingbg";
    this._loadingbg.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._loadingbg.ggVisible = true;
    this._loadingbg.className = "ggskin ggskin_rectangle ";
    this._loadingbg.ggType = "rectangle";
    hs = "";
    hs += cssPrefix + "border-radius : 10px;";
    hs += "border-radius : 10px;";
    hs += "background : #000000;";
    hs += "border : 0px solid #000000;";
    hs += "cursor : default;";
    hs += "height : 60px;";
    hs += "left : 0px;";
    hs += "opacity : 0.5;";
    hs += "position : absolute;";
    hs += "top : 0px;";
    hs += "visibility : inherit;";
    hs += "width : 210px;";
    hs += "pointer-events:auto;";
    this._loadingbg.setAttribute("style", hs);
    this._loadingbg.style[domTransform + "Origin"] = "50% 50%";
    me._loadingbg.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._loadingbg.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._loadingbg.ggUpdatePosition = function (useTransition) {};
    this._loading.appendChild(this._loadingbg);
    this._loadingbrd = document.createElement("div");
    this._loadingbrd.ggId = "loadingbrd";
    this._loadingbrd.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._loadingbrd.ggVisible = true;
    this._loadingbrd.className = "ggskin ggskin_rectangle ";
    this._loadingbrd.ggType = "rectangle";
    hs = "";
    hs += cssPrefix + "border-radius : 10px;";
    hs += "border-radius : 10px;";
    hs += "border : 2px solid #ffffff;";
    hs += "cursor : default;";
    hs += "height : 58px;";
    hs += "left : -1px;";
    hs += "opacity : 0.5;";
    hs += "position : absolute;";
    hs += "top : -1px;";
    hs += "visibility : inherit;";
    hs += "width : 208px;";
    hs += "pointer-events:auto;";
    this._loadingbrd.setAttribute("style", hs);
    this._loadingbrd.style[domTransform + "Origin"] = "50% 50%";
    me._loadingbrd.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._loadingbrd.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._loadingbrd.ggUpdatePosition = function (useTransition) {};
    this._loading.appendChild(this._loadingbrd);
    this._loadingtext = document.createElement("div");
    this._loadingtext__text = document.createElement("div");
    this._loadingtext.className = "ggskin ggskin_textdiv";
    this._loadingtext.ggTextDiv = this._loadingtext__text;
    this._loadingtext.ggId = "loadingtext";
    this._loadingtext.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._loadingtext.ggVisible = true;
    this._loadingtext.className = "ggskin ggskin_text ";
    this._loadingtext.ggType = "text";
    hs = "";
    hs += "height : 23px;";
    hs += "left : 16px;";
    hs += "position : absolute;";
    hs += "top : 12px;";
    hs += "visibility : inherit;";
    hs += "width : 176px;";
    hs += "pointer-events:auto;";
    this._loadingtext.setAttribute("style", hs);
    this._loadingtext.style[domTransform + "Origin"] = "0% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: auto;";
    hs += "height: auto;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._loadingtext__text.setAttribute("style", hs);
    this._loadingtext.ggUpdateText = function () {
      var hs =
        "Loading... " + (me.player.getPercentLoaded() * 100.0).toFixed(0) + "%";
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._loadingtext.ggUpdateText();
    this._loadingtext.appendChild(this._loadingtext__text);
    me._loadingtext.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._loadingtext.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._loadingtext.ggUpdatePosition = function (useTransition) {};
    this._loading.appendChild(this._loadingtext);
    this._loadingbar = document.createElement("div");
    this._loadingbar.ggId = "loadingbar";
    this._loadingbar.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._loadingbar.ggVisible = true;
    this._loadingbar.className = "ggskin ggskin_rectangle ";
    this._loadingbar.ggType = "rectangle";
    hs = "";
    hs += cssPrefix + "border-radius : 5px;";
    hs += "border-radius : 5px;";
    hs += "background : #ffffff;";
    hs += "border : 1px solid #808080;";
    hs += "cursor : default;";
    hs += "height : 12px;";
    hs += "left : 15px;";
    hs += "position : absolute;";
    hs += "top : 35px;";
    hs += "visibility : inherit;";
    hs += "width : 181px;";
    hs += "pointer-events:auto;";
    this._loadingbar.setAttribute("style", hs);
    this._loadingbar.style[domTransform + "Origin"] = "0% 50%";
    me._loadingbar.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._loadingbar.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._loadingbar.ggUpdatePosition = function (useTransition) {};
    this._loading.appendChild(this._loadingbar);
    this.divSkin.appendChild(this._loading);
    this._userdata = document.createElement("div");
    this._userdata.ggId = "userdata";
    this._userdata.ggLeft = -120;
    this._userdata.ggTop = -80;
    this._userdata.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._userdata.ggVisible = false;
    this._userdata.className = "ggskin ggskin_container ";
    this._userdata.ggType = "container";
    hs = "";
    hs += "height : 140px;";
    hs += "left : -120px;";
    hs += "position : absolute;";
    hs += "top : -80px;";
    hs += "visibility : hidden;";
    hs += "width : 240px;";
    hs += "pointer-events:none;";
    this._userdata.setAttribute("style", hs);
    this._userdata.style[domTransform + "Origin"] = "50% 50%";
    me._userdata.ggIsActive = function () {
      return false;
    };
    me._userdata.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    };
    this._userdata.onclick = function (e) {
      me._userdata.style[domTransition] = "none";
      me._userdata.style.visibility = "hidden";
      me._userdata.ggVisible = false;
    };
    this._userdata.ggUpdatePosition = function (useTransition) {
      if (useTransition === "undefined") {
        useTransition = false;
      }
      if (!useTransition) {
        this.style[domTransition] = "none";
      }
      if (this.parentNode) {
        var w = this.parentNode.offsetWidth;
        this.style.left = this.ggLeft - 0 + w / 2 + "px";
        var h = this.parentNode.offsetHeight;
        this.style.top = this.ggTop - 0 + h / 2 + "px";
      }
    };
    this._userdatabg = document.createElement("div");
    this._userdatabg.ggId = "userdatabg";
    this._userdatabg.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._userdatabg.ggVisible = true;
    this._userdatabg.className = "ggskin ggskin_rectangle ";
    this._userdatabg.ggType = "rectangle";
    hs = "";
    hs += cssPrefix + "border-radius : 10px;";
    hs += "border-radius : 10px;";
    hs += "background : #000000;";
    hs += "border : 0px solid #000000;";
    hs += "cursor : default;";
    hs += "height : 140px;";
    hs += "left : 0px;";
    hs += "opacity : 0.5;";
    hs += "position : absolute;";
    hs += "top : 0px;";
    hs += "visibility : inherit;";
    hs += "width : 240px;";
    hs += "pointer-events:auto;";
    this._userdatabg.setAttribute("style", hs);
    this._userdatabg.style[domTransform + "Origin"] = "50% 50%";
    me._userdatabg.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._userdatabg.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._userdatabg.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._userdatabg);
    this._userdatabrd = document.createElement("div");
    this._userdatabrd.ggId = "userdatabrd";
    this._userdatabrd.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._userdatabrd.ggVisible = true;
    this._userdatabrd.className = "ggskin ggskin_rectangle ";
    this._userdatabrd.ggType = "rectangle";
    hs = "";
    hs += cssPrefix + "border-radius : 10px;";
    hs += "border-radius : 10px;";
    hs += "border : 2px solid #ffffff;";
    hs += "cursor : default;";
    hs += "height : 138px;";
    hs += "left : -1px;";
    hs += "opacity : 0.5;";
    hs += "position : absolute;";
    hs += "top : -1px;";
    hs += "visibility : inherit;";
    hs += "width : 238px;";
    hs += "pointer-events:auto;";
    this._userdatabrd.setAttribute("style", hs);
    this._userdatabrd.style[domTransform + "Origin"] = "50% 50%";
    me._userdatabrd.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._userdatabrd.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._userdatabrd.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._userdatabrd);
    this._title = document.createElement("div");
    this._title__text = document.createElement("div");
    this._title.className = "ggskin ggskin_textdiv";
    this._title.ggTextDiv = this._title__text;
    this._title.ggId = "title";
    this._title.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._title.ggVisible = true;
    this._title.className = "ggskin ggskin_text ";
    this._title.ggType = "text";
    hs = "";
    hs += "height : 20px;";
    hs += "left : 10px;";
    hs += "position : absolute;";
    hs += "top : 10px;";
    hs += "visibility : inherit;";
    hs += "width : 218px;";
    hs += "pointer-events:auto;";
    this._title.setAttribute("style", hs);
    this._title.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: 218px;";
    hs += "height: 20px;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._title__text.setAttribute("style", hs);
    this._title.ggUpdateText = function () {
      var hs = "<b>" + me.ggUserdata.title + "</b>";
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._title.ggUpdateText();
    this._title.appendChild(this._title__text);
    me._title.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._title.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._title.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._title);
    this._description = document.createElement("div");
    this._description__text = document.createElement("div");
    this._description.className = "ggskin ggskin_textdiv";
    this._description.ggTextDiv = this._description__text;
    this._description.ggId = "description";
    this._description.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._description.ggVisible = true;
    this._description.className = "ggskin ggskin_text ";
    this._description.ggType = "text";
    hs = "";
    hs += "height : 20px;";
    hs += "left : 10px;";
    hs += "position : absolute;";
    hs += "top : 30px;";
    hs += "visibility : inherit;";
    hs += "width : 218px;";
    hs += "pointer-events:auto;";
    this._description.setAttribute("style", hs);
    this._description.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: 218px;";
    hs += "height: 20px;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._description__text.setAttribute("style", hs);
    this._description.ggUpdateText = function () {
      var hs = me.ggUserdata.description;
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._description.ggUpdateText();
    this._description.appendChild(this._description__text);
    me._description.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._description.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._description.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._description);
    this._author = document.createElement("div");
    this._author__text = document.createElement("div");
    this._author.className = "ggskin ggskin_textdiv";
    this._author.ggTextDiv = this._author__text;
    this._author.ggId = "author";
    this._author.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._author.ggVisible = true;
    this._author.className = "ggskin ggskin_text ";
    this._author.ggType = "text";
    hs = "";
    hs += "height : 20px;";
    hs += "left : 10px;";
    hs += "position : absolute;";
    hs += "top : 50px;";
    hs += "visibility : inherit;";
    hs += "width : 218px;";
    hs += "pointer-events:auto;";
    this._author.setAttribute("style", hs);
    this._author.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: 218px;";
    hs += "height: 20px;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._author__text.setAttribute("style", hs);
    this._author.ggUpdateText = function () {
      var hs = me.ggUserdata.author;
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._author.ggUpdateText();
    this._author.appendChild(this._author__text);
    me._author.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._author.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._author.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._author);
    this._datetime = document.createElement("div");
    this._datetime__text = document.createElement("div");
    this._datetime.className = "ggskin ggskin_textdiv";
    this._datetime.ggTextDiv = this._datetime__text;
    this._datetime.ggId = "datetime";
    this._datetime.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._datetime.ggVisible = true;
    this._datetime.className = "ggskin ggskin_text ";
    this._datetime.ggType = "text";
    hs = "";
    hs += "height : 23px;";
    hs += "left : 10px;";
    hs += "position : absolute;";
    hs += "top : 70px;";
    hs += "visibility : inherit;";
    hs += "width : 218px;";
    hs += "pointer-events:auto;";
    this._datetime.setAttribute("style", hs);
    this._datetime.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: auto;";
    hs += "height: auto;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._datetime__text.setAttribute("style", hs);
    this._datetime.ggUpdateText = function () {
      var hs = me.ggUserdata.datetime;
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._datetime.ggUpdateText();
    this._datetime.appendChild(this._datetime__text);
    me._datetime.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._datetime.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._datetime.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._datetime);
    this._copyright = document.createElement("div");
    this._copyright__text = document.createElement("div");
    this._copyright.className = "ggskin ggskin_textdiv";
    this._copyright.ggTextDiv = this._copyright__text;
    this._copyright.ggId = "copyright";
    this._copyright.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._copyright.ggVisible = true;
    this._copyright.className = "ggskin ggskin_text ";
    this._copyright.ggType = "text";
    hs = "";
    hs += "height : 23px;";
    hs += "left : 10px;";
    hs += "position : absolute;";
    hs += "top : 110px;";
    hs += "visibility : inherit;";
    hs += "width : 218px;";
    hs += "pointer-events:auto;";
    this._copyright.setAttribute("style", hs);
    this._copyright.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: auto;";
    hs += "height: auto;";
    hs += "border: 0px solid #000000;";
    hs += "color: rgba(255,255,255,1);";
    hs += "text-align: left;";
    hs += "white-space: nowrap;";
    hs += "padding: 0px 1px 0px 1px;";
    hs += "overflow: hidden;";
    this._copyright__text.setAttribute("style", hs);
    this._copyright.ggUpdateText = function () {
      var hs = "&#169; " + me.ggUserdata.copyright;
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._copyright.ggUpdateText();
    this._copyright.appendChild(this._copyright__text);
    me._copyright.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._copyright.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._copyright.ggUpdatePosition = function (useTransition) {};
    this._userdata.appendChild(this._copyright);
    this.divSkin.appendChild(this._userdata);
    this._hide_template = document.createElement("div");
    this._hide_template.ggId = "hide_template";
    this._hide_template.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._hide_template.ggVisible = false;
    this._hide_template.className = "ggskin ggskin_container ";
    this._hide_template.ggType = "container";
    hs = "";
    hs += "height : 45px;";
    hs += "left : 10px;";
    hs += "overflow : hidden;";
    hs += "position : absolute;";
    hs += "top : 10px;";
    hs += "visibility : hidden;";
    hs += "width : 187px;";
    hs += "pointer-events:none;";
    this._hide_template.setAttribute("style", hs);
    this._hide_template.style[domTransform + "Origin"] = "50% 50%";
    me._hide_template.ggIsActive = function () {
      return false;
    };
    me._hide_template.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    };
    this._hide_template.ggUpdatePosition = function (useTransition) {};
    this._markertemplate = document.createElement("div");
    this._markertemplate.ggMarkerNodeId = "";
    nodeMarker.push(this._markertemplate);
    this._markertemplate.ggId = "markertemplate";
    this._markertemplate.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._markertemplate.ggVisible = true;
    this._markertemplate.className = "ggskin ggskin_mark ";
    this._markertemplate.ggType = "mark";
    hs = "";
    hs += "height : 5px;";
    hs += "left : 60px;";
    hs += "position : absolute;";
    hs += "top : 0px;";
    hs += "visibility : inherit;";
    hs += "width : 5px;";
    hs += "pointer-events:auto;";
    this._markertemplate.setAttribute("style", hs);
    this._markertemplate.style[domTransform + "Origin"] = "50% 50%";
    me._markertemplate.ggIsActive = function () {
      return this.ggIsMarkerActive == true;
    };
    me._markertemplate.ggElementNodeId = function () {
      var hs = String(this.ggMarkerNodeId);
      if (hs.charAt(0) == "{") {
        return hs.substr(1, hs.length - 2);
      }
      return "";
    };
    this._markertemplate.onmouseover = function (e) {
      me._marker_title.style[domTransition] = "none";
      me._marker_title.style.visibility =
        Number(me._marker_title.style.opacity) > 0 ||
        !me._marker_title.style.opacity
          ? "inherit"
          : "hidden";
      me._marker_title.ggVisible = true;
    };
    this._markertemplate.onmouseout = function (e) {
      me._marker_title.style[domTransition] = "none";
      me._marker_title.style.visibility = "hidden";
      me._marker_title.ggVisible = false;
    };
    this._markertemplate.ggUpdateConditionNodeChange = function () {
      me._markertemplate__normal.ggNodeChangeMain();
      me._markertemplate__active.ggNodeChangeMain();
    };
    this._markertemplate.ggUpdatePosition = function (useTransition) {};
    this._markertemplate.ggNodeChange = function () {
      me._markertemplate.ggUpdateConditionNodeChange();
    };
    this._marker_title = document.createElement("div");
    this._marker_title__text = document.createElement("div");
    this._marker_title.className = "ggskin ggskin_textdiv";
    this._marker_title.ggTextDiv = this._marker_title__text;
    this._marker_title.ggId = "marker_title";
    this._marker_title.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._marker_title.ggVisible = false;
    this._marker_title.className = "ggskin ggskin_text ";
    this._marker_title.ggType = "text";
    hs = "";
    hs += "z-index: 100;";
    hs += "height : 17px;";
    hs += "left : -60px;";
    hs += "position : absolute;";
    hs += "top : 35px;";
    hs += "visibility : hidden;";
    hs += "width : 145px;";
    hs += "pointer-events:auto;";
    this._marker_title.setAttribute("style", hs);
    this._marker_title.style[domTransform + "Origin"] = "50% 50%";
    hs = "position:absolute;";
    hs += "cursor: default;";
    hs += "left: 0px;";
    hs += "top:  0px;";
    hs += "width: auto;";
    hs += "height: auto;";
    hs += "background: #ffffff;";
    hs += "background: rgba(255,255,255,0.705882);";
    hs += "border: 1px solid #000000;";
    hs += "border-radius: 5px;";
    hs += cssPrefix + "border-radius: 5px;";
    hs += "color: rgba(0,0,0,1);";
    hs += "text-align: center;";
    hs += "white-space: nowrap;";
    hs += "padding: 1px 2px 1px 2px;";
    hs += "overflow: hidden;";
    this._marker_title__text.setAttribute("style", hs);
    this._marker_title.ggUpdateText = function () {
      var hs = me.ggUserdata.title;
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    };
    me._marker_title.ggUpdateText();
    this._marker_title.appendChild(this._marker_title__text);
    me._marker_title.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._marker_title.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    };
    this._marker_title.ggUpdatePosition = function (useTransition) {
      this.style[domTransition] = "none";
      this.ggTextDiv.style.left = (149 - this.ggTextDiv.offsetWidth) / 2 + "px";
    };
    this._markertemplate.appendChild(this._marker_title);
    this._hide_template.appendChild(this._markertemplate);
    this.divSkin.appendChild(this._hide_template);
    this._markertemplate__normal = new SkinElement_marker_normal_Class(
      this,
      this._markertemplate
    );
    this._markertemplate__normal.style.visibility = "inherit";
    this._markertemplate__normal.style.left = "0px";
    this._markertemplate__normal.style.top = "0px";
    this._markertemplate.ggMarkerNormal = this._markertemplate__normal;
    this._markertemplate__active = new SkinElement_marker_active_Class(
      this,
      this._markertemplate
    );
    this._markertemplate__active.style.visibility = "hidden";
    this._markertemplate__active.style.left = "0px";
    this._markertemplate__active.style.top = "0px";
    this._markertemplate.ggMarkerActive = this._markertemplate__active;
    if (this._markertemplate.firstChild) {
      this._markertemplate.insertBefore(
        this._markertemplate__active,
        this._markertemplate.firstChild
      );
    } else {
      this._markertemplate.appendChild(this._markertemplate__active);
    }
    if (this._markertemplate.firstChild) {
      this._markertemplate.insertBefore(
        this._markertemplate__normal,
        this._markertemplate.firstChild
      );
    } else {
      this._markertemplate.appendChild(this._markertemplate__normal);
    }
    this.divSkin.ggUpdateSize = function (w, h) {
      me.updateSize(me.divSkin);
    };
    this.divSkin.ggViewerInit = function () {};
    this.divSkin.ggLoaded = function () {
      me._loading.style[domTransition] = "none";
      me._loading.style.visibility = "hidden";
      me._loading.ggVisible = false;
    };
    this.divSkin.ggReLoaded = function () {
      me._loading.style[domTransition] = "none";
      me._loading.style.visibility =
        Number(me._loading.style.opacity) > 0 || !me._loading.style.opacity
          ? "inherit"
          : "hidden";
      me._loading.ggVisible = true;
    };
    this.divSkin.ggLoadedLevels = function () {};
    this.divSkin.ggReLoadedLevels = function () {};
    this.divSkin.ggEnterFullscreen = function () {};
    this.divSkin.ggExitFullscreen = function () {};
    this.skinTimerEvent();
  };
  this.hotspotProxyClick = function (id) {};
  this.hotspotProxyOver = function (id) {};
  this.hotspotProxyOut = function (id) {};
  this.changeActiveNode = function (id) {
    me.ggUserdata = me.player.userdata;
    me._markertemplate.ggNodeChange();
    var newMarker = [];
    var i, j;
    var tags = me.ggUserdata.tags;
    for (i = 0; i < nodeMarker.length; i++) {
      var match = false;
      if (nodeMarker[i].ggMarkerNodeId == id && id != "") match = true;
      for (j = 0; j < tags.length; j++) {
        if (nodeMarker[i].ggMarkerNodeId == tags[j]) match = true;
      }
      if (match) {
        newMarker.push(nodeMarker[i]);
      }
    }
    for (i = 0; i < activeNodeMarker.length; i++) {
      if (newMarker.indexOf(activeNodeMarker[i]) < 0) {
        if (activeNodeMarker[i].ggMarkerNormal) {
          activeNodeMarker[i].ggMarkerNormal.style.visibility = "inherit";
        }
        if (activeNodeMarker[i].ggMarkerActive) {
          activeNodeMarker[i].ggMarkerActive.style.visibility = "hidden";
        }
        if (activeNodeMarker[i].ggDeactivate) {
          activeNodeMarker[i].ggDeactivate();
        }
        activeNodeMarker[i].ggIsMarkerActive = false;
      }
    }
    for (i = 0; i < newMarker.length; i++) {
      if (activeNodeMarker.indexOf(newMarker[i]) < 0) {
        if (newMarker[i].ggMarkerNormal) {
          newMarker[i].ggMarkerNormal.style.visibility = "hidden";
        }
        if (newMarker[i].ggMarkerActive) {
          newMarker[i].ggMarkerActive.style.visibility = "inherit";
        }
        if (newMarker[i].ggActivate) {
          newMarker[i].ggActivate();
        }
        newMarker[i].ggIsMarkerActive = true;
      }
    }
    activeNodeMarker = newMarker;
  };
  this.skinTimerEvent = function () {
    setTimeout(function () {
      me.skinTimerEvent();
    }, 10);
    me.ggCurrentTime = new Date().getTime();
    if (me.elementMouseDown["up"]) {
      me.player.changeTiltLog(1, true);
    }
    if (me.elementMouseDown["down"]) {
      me.player.changeTiltLog(-1, true);
    }
    if (me.elementMouseDown["left"]) {
      me.player.changePanLog(1, true);
    }
    if (me.elementMouseDown["right"]) {
      me.player.changePanLog(-1, true);
    }
    if (me.elementMouseDown["zoomin"]) {
      me.player.changeFovLog(-1, true);
    }
    if (me.elementMouseDown["zoomout"]) {
      me.player.changeFovLog(1, true);
    }
    me._loadingtext.ggUpdateText();
    var hs = "";
    if (me._loadingbar.ggParameter) {
      hs += parameterToTransform(me._loadingbar.ggParameter) + " ";
    }
    hs += "scale(" + (1 * me.player.getPercentLoaded() + 0) + ",1.0) ";
    me._loadingbar.style[domTransform] = hs;
    me._title.ggUpdateText();
    me._description.ggUpdateText();
    me._author.ggUpdateText();
    me._datetime.ggUpdateText();
    me._copyright.ggUpdateText();
    me._marker_title.ggUpdateText();
  };

  function SkinHotspotClass(skinObj, hotspot) {
    var me = this;
    var flag = false;
    this.player = skinObj.player;
    this.skin = skinObj;
    this.hotspot = hotspot;
    var nodeId = String(hotspot.url);
    nodeId = nodeId.charAt(0) == "{" ? nodeId.substr(1, nodeId.length - 2) : "";
    this.ggUserdata = this.skin.player.getNodeUserdata(nodeId);
    this.elementMouseDown = [];
    this.elementMouseOver = [];

    this.findElements = function (id, regex) {
      return me.skin.findElements(id, regex);
    };

    {
      this.__div = document.createElement("div");
      this.__div.ggId = "hotspot";
      this.__div.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
      this.__div.ggVisible = true;
      this.__div.className = "ggskin ggskin_hotspot ";
      this.__div.ggType = "hotspot";
      hs = "";
      hs += "height : 5px;";
      hs += "left : 350px;";
      hs += "position : absolute;";
      hs += "top : 20px;";
      hs += "visibility : inherit;";
      hs += "width : 5px;";
      hs += "pointer-events:auto;";
      this.__div.setAttribute("style", hs);
      this.__div.style[domTransform + "Origin"] = "50% 50%";
      me.__div.ggIsActive = function () {
        return me.player.getCurrentNode() == this.ggElementNodeId();
      };
      me.__div.ggElementNodeId = function () {
        return me.hotspot.url.substr(1, me.hotspot.url.length - 2);
      };
      this.__div.onclick = function (e) {
        me.player.openUrl(me.hotspot.url, me.hotspot.target);
        me.skin.hotspotProxyClick(me.hotspot.id);
      };
      this.__div.onmouseover = function (e) {
        me.player.setActiveHotspot(me.hotspot);
        me._hstext.style[domTransition] = "none";
        me._hstext.style.visibility =
          Number(me._hstext.style.opacity) > 0 || !me._hstext.style.opacity
            ? "inherit"
            : "hidden";
        me._hstext.ggVisible = true;
        me.skin.hotspotProxyOver(me.hotspot.id);
      };
      this.__div.onmouseout = function (e) {
        me.player.setActiveHotspot(null);
        me._hstext.style[domTransition] = "none";
        me._hstext.style.visibility = "hidden";
        me._hstext.ggVisible = false;
        me.skin.hotspotProxyOut(me.hotspot.id);
      };
      this.__div.ggUpdatePosition = function (useTransition) {};
      this._hsimage = document.createElement("div");
      this._hsimage__img = document.createElement("img");
      this._hsimage__img.className = "ggskin ggskin_svg";
      this._hsimage__img.setAttribute("src", basePath + "images/hsimage.svg");
      this._hsimage__img.setAttribute(
        "style",
        "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
      );
      this._hsimage__img["ondragstart"] = function () {
        return false;
      };
      this._hsimage.appendChild(this._hsimage__img);
      this._hsimage.ggId = "hsimage";
      this._hsimage.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
      this._hsimage.ggVisible = true;
      this._hsimage.className = "ggskin ggskin_svg ";
      this._hsimage.ggType = "svg";
      hs = "";
      hs += "cursor : pointer;";
      hs += "height : 32px;";
      hs += "left : -16px;";
      hs += "position : absolute;";
      hs += "top : -16px;";
      hs += "visibility : inherit;";
      hs += "width : 32px;";
      hs += "pointer-events:auto;";
      this._hsimage.setAttribute("style", hs);
      this._hsimage.style[domTransform + "Origin"] = "50% 50%";
      me._hsimage.ggIsActive = function () {
        if (this.parentNode && this.parentNode.ggIsActive) {
          return this.parentNode.ggIsActive();
        }
        return false;
      };
      me._hsimage.ggElementNodeId = function () {
        if (this.parentNode && this.parentNode.ggElementNodeId) {
          return this.parentNode.ggElementNodeId();
        }
        return me.ggNodeId;
      };
      this._hsimage.ggUpdatePosition = function (useTransition) {};
      this.__div.appendChild(this._hsimage);
      this._hstext = document.createElement("div");
      this._hstext__text = document.createElement("div");
      this._hstext.className = "ggskin ggskin_textdiv";
      this._hstext.ggTextDiv = this._hstext__text;
      this._hstext.ggId = "hstext";
      this._hstext.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
      this._hstext.ggVisible = false;
      this._hstext.className = "ggskin ggskin_text ";
      this._hstext.ggType = "text";
      hs = "";
      hs += "z-index: 100;";
      hs += "height : 17px;";
      hs += "left : -50px;";
      hs += "position : absolute;";
      hs += "top : 20px;";
      hs += "visibility : hidden;";
      hs += "width : 95px;";
      hs += "pointer-events:auto;";
      this._hstext.setAttribute("style", hs);
      this._hstext.style[domTransform + "Origin"] = "50% 50%";
      hs = "position:absolute;";
      hs += "cursor: default;";
      hs += "left: 0px;";
      hs += "top:  0px;";
      hs += "width: auto;";
      hs += "height: auto;";
      hs += "background: #ffffff;";
      hs += "background: rgba(255,255,255,0.705882);";
      hs += "border: 1px solid #000000;";
      hs += "border-radius: 5px;";
      hs += cssPrefix + "border-radius: 5px;";
      hs += "color: rgba(0,0,0,1);";
      hs += "text-align: center;";
      hs += "white-space: nowrap;";
      hs += "padding: 1px 2px 1px 2px;";
      hs += "overflow: hidden;";
      this._hstext__text.setAttribute("style", hs);
      this._hstext__text.innerHTML = me.hotspot.title;
      this._hstext.appendChild(this._hstext__text);
      me._hstext.ggIsActive = function () {
        if (this.parentNode && this.parentNode.ggIsActive) {
          return this.parentNode.ggIsActive();
        }
        return false;
      };
      me._hstext.ggElementNodeId = function () {
        if (this.parentNode && this.parentNode.ggElementNodeId) {
          return this.parentNode.ggElementNodeId();
        }
        return me.ggNodeId;
      };
      this._hstext.ggUpdatePosition = function (useTransition) {
        this.style[domTransition] = "none";
        this.ggTextDiv.style.left =
          (99 - this.ggTextDiv.offsetWidth) / 2 + "px";
      };
      this.__div.appendChild(this._hstext);
    }
  }
  this.addSkinHotspot = function (hotspot) {
    return new SkinHotspotClass(me, hotspot);
  };

  function SkinElement_marker_active_Class(skinObj, ggParent) {
    var me = this;
    var flag = false;
    this.player = skinObj.player;
    this.skin = skinObj;
    this.ggParent = ggParent;
    var nodeId = ggParent.ggElementNodeId();
    this.ggNodeId = nodeId;
    this.ggUserdata = this.skin.player.getNodeUserdata(nodeId);
    this.elementMouseDown = [];
    this.elementMouseOver = [];

    this.findElements = function (id, regex) {
      return me.skin.findElements(id, regex);
    };

    this._marker_active = document.createElement("div");
    this._marker_active__img = document.createElement("img");
    this._marker_active__img.className = "ggskin ggskin_svg";
    this._marker_active__img.setAttribute(
      "src",
      basePath + "images/marker_active.svg"
    );
    this._marker_active__img.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
    );
    this._marker_active__img["ondragstart"] = function () {
      return false;
    };
    this._marker_active.appendChild(this._marker_active__img);
    this._marker_active.ggId = "marker_active";
    this._marker_active.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._marker_active.ggVisible = true;
    this._marker_active.className = "ggskin ggskin_svg ";
    this._marker_active.ggType = "svg";
    hs = "";
    hs += "height : 31px;";
    hs += "left : 105px;";
    hs += "position : absolute;";
    hs += "top : 0px;";
    hs += "visibility : inherit;";
    hs += "width : 31px;";
    hs += "pointer-events:auto;";
    this._marker_active.setAttribute("style", hs);
    this._marker_active.style[domTransform + "Origin"] = "50% 50%";
    me._marker_active.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._marker_active.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.ggNodeId;
    };
    this._marker_active.ggUpdatePosition = function (useTransition) {};
    this._marker_active.ggNodeChangeMain = function () {};
    return this._marker_active;
  }

  function SkinElement_marker_normal_Class(skinObj, ggParent) {
    var me = this;
    var flag = false;
    this.player = skinObj.player;
    this.skin = skinObj;
    this.ggParent = ggParent;
    var nodeId = ggParent.ggElementNodeId();
    this.ggNodeId = nodeId;
    this.ggUserdata = this.skin.player.getNodeUserdata(nodeId);
    this.elementMouseDown = [];
    this.elementMouseOver = [];

    this.findElements = function (id, regex) {
      return me.skin.findElements(id, regex);
    };

    this._marker_normal = document.createElement("div");
    this._marker_normal__img = document.createElement("img");
    this._marker_normal__img.className = "ggskin ggskin_svg";
    this._marker_normal__img.setAttribute(
      "src",
      basePath + "images/marker_normal.svg"
    );
    this._marker_normal__img.setAttribute(
      "style",
      "position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;"
    );
    this._marker_normal__img["ondragstart"] = function () {
      return false;
    };
    this._marker_normal.appendChild(this._marker_normal__img);
    this._marker_normal.ggId = "marker_normal";
    this._marker_normal.ggParameter = { rx: 0, ry: 0, a: 0, sx: 1, sy: 1 };
    this._marker_normal.ggVisible = true;
    this._marker_normal.className = "ggskin ggskin_svg ";
    this._marker_normal.ggType = "svg";
    hs = "";
    hs += "height : 32px;";
    hs += "left : 140px;";
    hs += "position : absolute;";
    hs += "top : 0px;";
    hs += "visibility : inherit;";
    hs += "width : 31px;";
    hs += "pointer-events:auto;";
    this._marker_normal.setAttribute("style", hs);
    this._marker_normal.style[domTransform + "Origin"] = "50% 50%";
    me._marker_normal.ggIsActive = function () {
      if (this.parentNode && this.parentNode.ggIsActive) {
        return this.parentNode.ggIsActive();
      }
      return false;
    };
    me._marker_normal.ggElementNodeId = function () {
      if (this.parentNode && this.parentNode.ggElementNodeId) {
        return this.parentNode.ggElementNodeId();
      }
      return me.ggNodeId;
    };
    this._marker_normal.ggUpdatePosition = function (useTransition) {};
    this._marker_normal.ggNodeChangeMain = function () {};
    return this._marker_normal;
  }
  this.addSkin();
}

window.pano2vrSkin = pano2vrSkin;
